// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"543":"gallery","671":"services"}[chunkId] + "." + {"543":"097eab5e","671":"d8538937"}[chunkId] + ".css";
};